// extracted by mini-css-extract-plugin
export default {"bar":"VendorDepositSaveBar_bar__ocCLT","count":"VendorDepositSaveBar_count__bdb3P","actions":"VendorDepositSaveBar_actions__R0LA9"};